import React from "react";
import "./header.css";

export default function Header({title}) {
  return (
    <div className="headerContainer">
      <div className="sideContent">
        <div className="headerContent">
          <h1>{title}</h1>
          <h2>
            These are the most common type of solar mounting system and are
            installed on the rooftops of buildings.
          </h2>
        </div>
      </div>
      <img src="./images/Carousel/sturcture.webp" alt="headerImages"></img>
    </div>
  );
}
